import React, { useEffect } from 'react';
import { Box, Modal, Typography, Button } from '@mui/material';
import mermaid from 'mermaid';

interface MermaidModalProps {
  open: boolean;
  onClose: () => void;
  diagramScript: string;
  title: string;
}

const MermaidModal: React.FC<MermaidModalProps> = ({ open, onClose, diagramScript, title }) => {
  useEffect(() => {
    if (open && title !== 'API Schema') {
      // Initialize Mermaid
      mermaid.initialize({ startOnLoad: true });

      // Add a timeout to ensure the DOM is fully mounted
      const timeoutId = setTimeout(() => {
        const container = document.getElementById('mermaid-diagram-container');
        if (container) {
          try {
            // Clear the container to ensure fresh rendering
            container.innerHTML = '';
            // Inject the Mermaid script directly into the container
            container.innerHTML = `<div class="mermaid">${diagramScript}</div>`;
            // Trigger Mermaid to process the content
            mermaid.contentLoaded();
          } catch (error) {
            console.error('Failed to render Mermaid diagram:', error);
            container.innerHTML = `<p style="color: red;">Failed to render diagram. Please check the script.</p>`;
          }
        }
      }, 100); // Timeout duration (100ms)

      // Cleanup timeout on component unmount
      return () => clearTimeout(timeoutId);
    }
  }, [open, diagramScript]);
  
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '80%',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <Box id="mermaid-diagram-container" sx={{ overflow: 'auto', maxHeight: '70vh' }}>
          {/* Mermaid diagram will be rendered here */}
          {title === 'API Schema' ? (
            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
              {diagramScript}
            </pre>
          ) : null}
        </Box>
      </Box>
    </Modal>
  );
};

export default MermaidModal;